import React, { PropTypes } from 'react'
import LoginForm from './LoginForm';
import UserService from '../services/UserService';
import Auth from '../modules/Auth';
import SweetAlert from 'sweetalert-react';
import 'sweetalert/dist/sweetalert.css';


class LoginContainer extends React.Component {

  constructor(props,context) {
    super(props,context);

    // set the initial component state
    this.state = {
      errors: {},
      user: {
        email: '',
        password: ''
      },
      showAlert:false,
      message:''
    };

    this.processForm = this.processForm.bind(this);
    this.changeUser = this.changeUser.bind(this);
  }

  componentDidMount(){

  }

  /**
   * Process the form.
   *
   * @param {object} event - the JavaScript event object
   */
  processForm(event) {
    // prevent default action. in this case, action is the form submission event
    event.preventDefault();

    console.log('email:', this.state.user.email);
    console.log('password:', this.state.user.password);
    UserService.login(this.state.user).then(response => {
        console.log(response);
        var data = response.data;
        Auth.authenticateUser(data.auth_token);
        this.context.router.replace('/dashboard');
    })
    .catch(error => {
      console.log("OCurrio un error",error);
      this.setState({showAlert:true, message:'Usuario o Password Invalido'})
    });
  }

  /**
   * Change the user object.
   *
   * @param {object} event - the JavaScript event object
   */
  changeUser(event) {
    const field = event.target.name;
    const user = this.state.user;
    user[field] = event.target.value;

    this.setState({
      user
    });
  }

  /**
   * Render the component.
   */
  render() {
    return (
      <div className="section">
      <LoginForm
        onSubmit={this.processForm}
        onChange={this.changeUser}
        errors={this.state.errors}
        user={this.state.user}
      />
      <SweetAlert
          show={this.state.showAlert}
          title="Error"
          type="error"
          text={this.state.message}
          onConfirm={() => this.setState({ showAlert: false })}
        />
      </div>
    );
  }
}

LoginContainer.contextTypes = {
  router: PropTypes.object.isRequired
};


export default LoginContainer;



// WEBPACK FOOTER //
// ./src/components/LoginContainer.js